import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';
// import PropTypes from 'prop-types';
import Row from "../../shared/components/Row";
import Card from "../../shared/components/Card";
import CardHeader from "../../shared/components/card-header/CardHeader";
import {I18nUtils} from "../../../i18n/I18nUtils";
import HeaderSearchRefreshFilterOptions from "../../shared/components/HeaderSearchRefreshFilterOptions";
import Paginator from "../../shared/components/Paginator";
import CardBody from "../../shared/components/CardBody";
import * as schemeDocumentsActions from '../actions/schemesDocumentsActions';
import SchemeDocumentsTable from "./SchemeDocumentsTable";
import StateManager from "../../shared/utils/StateManager";

class SchemeDocumentsCard extends React.Component {

  STATE_MANAGER_KEY = 'SCHEME_DOCUMENTS_CARD';

  constructor(props){
    super(props);

    this.onRefresh = this.onRefresh.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onPage = this.onPage.bind(this);

    this.state = StateManager.getState(this.STATE_MANAGER_KEY);
  }


  componentWillMount(){
    this.getSchemeDocuments();
  }

  componentDidUpdate( prevProps, prevState ){
    if ( prevState.search !== this.state.search
      || prevState.filter !== this.state.filter
      || prevState.page !== this.state.page ){
      this.getSchemeDocuments();
    }
    StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
  }

  getSchemeDocuments(){
    this.props.schemeDocumentsActions.getSchemesDocuments(this.state.page, this.state.search, this.state.filter);
  }

  onRefresh(){
    this.getSchemeDocuments()
  }

  onSearch(search){
    this.setState({ search: search, page: 1 });
  }

  onPage(page){
    this.setState({ page })
  }

  renderFilterName(){
    const states = _.keyBy(this.props.schemaOptions, 'id');
    if (states && states[this.state.filter]){
      return states[this.state.filter].name;
    }
    return '';
  }

  renderHeaderOptions(){

    const filterOptions = this.props.schemaOptions.map((scheme) => {
      return {
        title: scheme.name,
        active: scheme.id === this.state.filter,
        onClick: () => {
          this.setState({ filter: scheme.id, page: 1 });
        },
      }
    });

    return(
      <HeaderSearchRefreshFilterOptions
        onRefresh={this.onRefresh}
        onSearch={this.onSearch}
        searchText={this.state.search}
        filterOptions={filterOptions}
      />
    );

  }


  render() {
    return (
      <Row>
        <Card loading={this.props.schemeDocumentsLoading}>
          <CardHeader
            title={I18nUtils.tr('TR_ESQUEMAS_DE_DOCUMENTOS').toUpperCase()}
            subtitle={this.renderFilterName()}
            rightOptions={this.renderHeaderOptions()}
          />
          <CardBody>
            <SchemeDocumentsTable data={this.props.schemeDocuments} error={this.props.schemeDocumentsError}/>
            <Paginator
              data={this.props.schemeDocumentsPagination}
              onPage={this.onPage}
            />
          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = state => {

  let errorMessage = state.schemeDocuments.schemeDocumentsError;
  if (!errorMessage && Object.keys(state.schemeDocuments.schemeDocuments).length === 0 && !state.schemeDocuments.schemeDocumentsLoading){
    errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
  }

  let schemaOptions = state.schemaType.schemaType.map((schema) => {
    return {
      id: schema.id,
      name: schema.name,
    };
  });
  schemaOptions = [{id: 0, name: I18nUtils.tr('TR_TODOS')}, ...schemaOptions];

  return({
    schemeDocuments: state.schemeDocuments.schemeDocuments,
    schemeDocumentsPagination: state.schemeDocuments.schemeDocumentsPagination,
    schemeDocumentsLoading: state.schemeDocuments.schemeDocumentsLoading,
    schemeDocumentsError: errorMessage,
    schemaOptions: schemaOptions
  });
};

const mapDispatchToProps = dispatch => ({
  schemeDocumentsActions: bindActionCreators(schemeDocumentsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchemeDocumentsCard);

SchemeDocumentsCard.propTypes = {};

SchemeDocumentsCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/SchemeDocumentsCard.js